export default __webpack_public_path__ + "static/media/blog-arturoFuente24.ddd50e61.png";